//--------------------------------------------------
// imported classes
//--------------------------------------------------
const DataConvertor = require('../core/DataConvertor')
const ClassFunc = require('../util/ClassFunc')
const ObjectFunc = require('../util/ObjectFunc')
const GlobalFunc = require('../util/GlobalFunc')
const AbstractMediator = require('../core/AbstractMediator')
const ModelLocator = require('../model/ModelLocator')
const DSBridge = require('../../libs/ds-bridge')
const wx = require('weixin-js-sdk')

/**
 * The BaseMediator class works as the basic mediator to maintain
 * the business logic for the scene instance.
 * It provides the basic features for the resource CRUD operations.
 * It would query the data via the service if list condition.
 * It would fetch the data via the service if not create condition.
 * It would submit the data via the event if create or update condition.
 * It would delete the data via the event if delete condition.
 */
const tbs_controller_BaseMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, AbstractMediator, arguments)
    // console.log('tbs_controller_BaseMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_BaseMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    onCreationComplete: function() {
        this.handleCreationComplete()
    },
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
        // console.log('handleCreationComplete')
        const query = this._bridge.getRouteQuery()
        if (this.target().filter && !ObjectFunc.isEmpty(query)) {
            ObjectFunc.mergeObject(this.target().filter, ObjectFunc.cloneObject(query))
        }
        this.creationComplete()
    },
    handleParentEvent: function(event) {
        this.handleCustomEvent(event)
    },
    /**
     * @api
     * Handle the custom event condition triggered by 
     * the scene instance.
     * @event The event object contains 
     * {type:String, data:Object, target:VueComponent}
     */
    handleCustomEvent: function(event) {
        // console.log('handleCustomEvent', event)
        // use the customized event handler within the specific mediator
        // if event is handled with null return value, skip the following handler
        if (this.handleCustomizedEvent) {
            if (!this.handleCustomizedEvent(event)) {
                return
            }
        }
        if (event.type == 'save') {
            this.submitData(event.target, event.data, true)
        }
        else if (event.type == 'submit') {
            this.submitData(event.target, event.data)
        }
        else if (event.type == 'delete') {
            this.deleteRecord(event.target, event.data)
        }
        else if (event.type == 'navigate') {
            if (event.data.name) {
                this._bridge.goToScene(event.data.name, event.data.params, ObjectFunc.mergeObject(this._bridge.getRouteQuery(), event.data.query), event.data.isReplace)
            }
            else if (event.data.path) {
                this._bridge.goToPath(event.data.path, ObjectFunc.mergeObject(this._bridge.getRouteQuery(), event.data.query))
            }
            else if (event.data.url) {
                this._bridge.goToUrl(event.data.url)
            }
            else if (event.data.action) {
                if (event.data.action == 'exit') {
                    this.exitPage()
                }
            }
            else if (event.data.wxmpPath) {
                this.goToWXMPUrl(event.data.wxmpPath, event.data.query)
            }
            if (event.data.reload) {
                this._bridge.reload()
            }
        }
        else if (event.type == 'updateQuery') {
            this._bridge.replaceQuery(ObjectFunc.mergeObject(this._bridge.getRouteQuery(), event.data.query))
            this.creationComplete()
        }
    },
    
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    /**
     * @private
     * Try to render the component according to the service data.
     * Here's the main steps:
     * Load the entity object via the service API request.
     * Convert the entity object into the view object according to the
     * declared view object model.
     * Set the bindable data model via the wrapper for the vue component.
     */
    creationComplete: function(parameters) {
        // console.log('creationComplete', parameters, this._bridge.getRouteName())
        var self = this
        // mark the isEdit flag as true if edit page
        if (self._bridge.isEdit()) {
            self.target().isEdit = true
        }
        // merge the route parameter and query into the parameters
        parameters = parameters || {}
        const routeParameters = {}
        ObjectFunc.mergeObject(routeParameters, self._bridge.getRouteParam())
        ObjectFunc.mergeObject(routeParameters, self._bridge.getRouteQuery())
        this.queryData(ObjectFunc.mergeObject(routeParameters, parameters))
    },
    queryData: function(parameters) {
        var self = this
        parameters = self.handleDataLoad(parameters)
        let type 
        type = self._bridge.isList() ? 'query' : 'get'
        type = self._bridge.isManage() ? 'manage' : type
        type = self._bridge.isCreate() ? 'prefetch': type
        type = self._bridge.isEdit() ? 'fetch' : type
        // console.log('queryData', type, parameters)
        self.loadViewObjectData(self.convertor(), parameters, function(viewData) {
            // console.log('viewData', viewData)
            const wrapper = DataConvertor.wrapper(self.convertor(), self._bridge.isList())
            // console.log('@wrapper-viewData', wrapper, viewData)
            // console.log('@target', self.target(), wrapper)
            if (self.handleViewDataWrap(viewData)) {
                // console.log('before set wrapper for the target', wrapper)
                if (wrapper) {
                    // console.log('@wrapper-viewData', wrapper, viewData)
                    self.target()[wrapper] = viewData
                }
                else {
                    for (let p in viewData) {
                        // console.log('@wrapper-viewData', p, viewData[p])
                        self.target()[p] = viewData[p]
                    }
                }
            }
            self.onDataLoaded(viewData)
        }, type)
    },
    handleDataLoad: function(parameters) {
        // console.log('@BaseMediator.handleDataLoad', parameters)
        return parameters
    },
    onDataLoaded: function(viewData) {
        if (this.target().isRoot) {
            this.target().parentUpdated()
        }
        /*if (this.target().isLoading) {
            console.log('change isLoading as false')
            this.target().isLoading = false
        }*/
        this.target().isLoading = false
        // console.log('before handleDataLoaded', this.target().isLoading)
        this.handleDataLoaded(viewData)
    },
    handleDataLoaded: function() {
        // console.log('@BaseMediator.handleDataLoaded')
    },
    handleViewDataWrap: function() {
        return true
    },
    submitData: function(target, data, isSaved) {
        // console.log('submitData', target, data)
        if (isSaved) {
            GlobalFunc.clearExecute(this)
            return this.doSubmitData(target, data, isSaved)
        }

        if (this._bridge.isCreate()) {
            this.doSubmitData(target, data)
        }
        else if (this._bridge.isBatch()) {
            // check the empty item existed or not
            if (this.target().isEdit) {
                this.checkEmptyItemExisted(data)
                GlobalFunc.delayExecute(this, 'doSubmitBatchData', 1000, [target, data])
            }
            else {
                this.doSubmitBatchData(target, data)
            }
        }
        else {
            GlobalFunc.delayExecute(this, 'doSubmitData', 1000, [target, data])
        }
    },
    checkEmptyItemExisted: function(data) {
        console.log('checkEmptyItemExisted', data)
    },
    doSubmitBatchData: function(target, data) {
        console.log('doSubmitBatchData', target, data)
    },
    /**
     * @private
     * Delete the data record via the id.
     */
    deleteRecord: function(target, data) {
        // console.log('deleteRecord', target, data)
        const self = this
        const convertor = self.p_convertor()
        const submitData = ObjectFunc.mergeObject({id: self._bridge.getRouteParam('id')}, data)
        self.commitViewObjectData(convertor, submitData, function(data) {
            // console.log('remove.data', data)
            self.handleRemoveService(data)
        }, 'remove')
    },
    /**
     * @private
     * Create the data record if no id there.
     * Update the data record if id existed.
     */
    doSubmitData: function(target, data, isSaved) {
        // console.log('doSubmitData', target, data, isSaved)
        const self = this
        const convertor = self.p_convertor()
        const isCreate = self._bridge.isCreate()
        // compare the submit data
        let isEqual = true
        let submitData = {}
        this._prevSubmitData = this._prevSubmitData || {}
        const prevSubmitData = this._prevSubmitData
        for (let p in data) {
            // console.log('compare prev and cur', p, prevSubmitData[p] == data[p])
            if (data[p] != prevSubmitData[p]) {
                isEqual = false
                submitData[p] = data[p]
            }
            prevSubmitData[p] = data[p]
        }
        // console.log('isEqual', isEqual)
        if (isEqual) {
            if (isSaved) {
                self._bridge.triggerRouteBack()
            }
            return
        }
        // console.log('submitData', submitData, isCreate, isSaved)
        const type = isCreate ? 'create' : 'update'
        self.commitViewObjectData(convertor, submitData, function(data) {
            // console.log('submit.data', data)
            if (type == 'create') {
                self.handleCreateService(data)
            }
            else if (type == 'update') {
                self.handleUpdateService(data)
                if (isSaved) {
                    self._bridge.triggerRouteBack()
                }
            }
        }, type)
    },
    handleRemoveService: function(e) {
        if (e.data.result == true) {
            this._bridge.back()
        }
    },
    handleCreateService: function(e) {
        if (e.data.result == true) {
            // console.log('handleCreateService validate cached', this.properties().cached)
            if (this.properties().cached) {
                // console.log('clear the status', this._bridge.getRouteName())
                ModelLocator.setStatus(this._bridge.getRouteName(), null)
            }
            this._bridge.back()
        }
    },
    handleUpdateService: function() {
    },
    loadViewObjectData: function(convertor, parameters, callback, type) {
        const self = this
        type = type || 'get'
        const source = convertor.view[type]
        if (source == null) {
            return
        }
        // console.log('@source', source)
        const wrapper = DataConvertor.wrapper(convertor)
        const service = type + ObjectFunc.capitalizeFirstLetter(wrapper)
        parameters = DataConvertor.queryTransform(convertor, parameters, type)
        // console.log('parameters', parameters, ClassFunc.getClass(source))
        if (ClassFunc.getClass(source) == 'Array') {
            self._bridge.addResourceListener(service, function(e) {
                self._bridge.removeResourceListener(service, e.handler)
                // console.log('collection.get.data', service, e.data)
                let viewData = {}
                let dataSets = e.data.dataSets
                let transformedDataSets = []
                for (let i = 0; i < dataSets.length; i++) {
                    let dataSet = dataSets[i]
                    if (dataSet.result) {
                        let item = convertor.view[type][i]
                        const transformedData = DataConvertor.doTransform(convertor, item.basePath, item.rule, dataSet.payload, type, dataSet.options, transformedDataSets, i)
                        transformedDataSets.push(transformedData)
                        // console.log('@transformedData', item.name, viewData[item.name] ? true : false)
                        if (item.name) {
                            if (viewData[item.name]) {
                                ObjectFunc.mergeObject(viewData[item.name], transformedData)
                            }
                            else {
                                // console.log('set the view data via', item.name, transformedData)
                                viewData[item.name] = transformedData
                            }
                        }
                        else {
                            ObjectFunc.mergeObject(viewData, transformedData)
                        }
                    }
                }
                // console.log('before callback', callback ? true : false)
                callback && callback(viewData)
            })
            self._bridge.callResourceInstance(service, {
                services: ObjectFunc.extractProperties(source, ['baseUrl', 'apiPrefix', 'apiSuffix', 'service', 'seq']),
                method: 'GET',
                parameters: parameters
            }, true)
        }
        else {
            self._bridge.addResourceListener(service, function(e) {
                self._bridge.removeResourceListener(service, e.handler)
                // console.log('single.get.data', service, e.data)
                const viewData = DataConvertor.transform(convertor, e.data.payload, type, e.data.options)
                // console.log('viewData', viewData)
                callback && callback(viewData, source.name)
            })
            self._bridge.callResourceInstance(service, {
                baseUrl: source.baseUrl,
                apiPrefix: source.apiPrefix,
                apiSuffix: source.apiSuffix,
                serviceName: source.service,
                method: 'GET',
                parameters: parameters
            })
        }
    },
    commitViewObjectData: function(convertor, parameters, callback, type) {
        // console.log('commitViewObjectData', parameters, type)
        const self = this
        type = type || 'create'
        const routeParam = ObjectFunc.cloneObject(self._bridge.getRouteParam())
        const routeQuery = ObjectFunc.cloneObject(self._bridge.getRouteQuery())
        const options = ObjectFunc.mergeObject(routeParam, routeQuery)
        const postBody = DataConvertor.transform(convertor, parameters, type, options)
        const source = convertor.view[type]
        const wrapper = DataConvertor.wrapper(convertor)
        const service = type + ObjectFunc.capitalizeFirstLetter(wrapper)
        parameters = DataConvertor.queryTransform(convertor, parameters, type)
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            // console.log('service response data', service, e.data)
            callback && callback(e)
        })
        // console.log('before service call', service, postBody)
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'POST',
            data: postBody
        })
    },
    exitPage: function() {
        console.log('exit page via DSBridge')
        DSBridge.exitPage()
    },
    goToWXMPUrl: function(path, query) {
        let url = path
        if (query) {
            url += '?' + ObjectFunc.toPairString(query)
        }
        console.log('goToWXMPUrl', url)
        wx.miniProgram.navigateTo({
            url: url
        })
    },
}

//--------------------------------------------------
// extends the AbstractMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_BaseMediator, AbstractMediator);

module.exports = tbs_controller_BaseMediator